import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomPipeModule } from './pipes/pipe.module';
import { AccountService } from './services/account.service';
import { AlertService } from './services/alert.service';
import { IconService } from './services/icon.service';
import { RequestService } from './services/request.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, ReactiveFormsModule, FormsModule, CustomPipeModule],
  exports: [ReactiveFormsModule, FormsModule, CustomPipeModule],
  providers: [
    DatePipe,
    TitleCasePipe,
    RequestService,
    AccountService,
    IconService,
    AlertService,
  ],
})
export class CoreModule {}
